/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */

import Checkbox from 'settings/page-elements/dropdown/Checkbox';

export const POPUP_FOOTER_VARIANTS = {
  EXIT: 'EXIT',
  BILLING: 'BILLING',
  SEND: 'SEND',
  ONLINE: 'ONLINE',
  OK: 'OK',
  DEFAULT: 'DEFAULT',
};

const PopupFooter = ({
  finalAgreeToSend,
  footerInfo,
  fromAppointment,
  isReceptionist,
  leftButtonClick,
  leftButtonTitle,
  rightButtonClick,
  rightButtonTitle,
  sendSMSVisibility,
  setFinalAgreeToSend,
  withCheckBox,
  variant,
}) => {
  let footerClassName = '';

  switch (variant) {
    case POPUP_FOOTER_VARIANTS.SEND:
      footerClassName = fromAppointment
        ? 'footer-marketing-sendsms cfix fromAppointment'
        : 'footer-marketing-sendsms cfix fromMarketing';
      break;
    case POPUP_FOOTER_VARIANTS.BILLING:
      footerClassName = 'footer-marketing-goto-billing cfix';
      break;
    case POPUP_FOOTER_VARIANTS.EXIT:
      footerClassName = 'footer-marketing-exit cfix';
      break;
    case POPUP_FOOTER_VARIANTS.ONLINE:
      footerClassName = 'footer-marketing-goto-onlione-booking cfix';
      break;
    case POPUP_FOOTER_VARIANTS.OK:
      footerClassName = 'footer-marketing-consultation cfix';
      break;
    case POPUP_FOOTER_VARIANTS.DEFAULT:
      footerClassName = 'footer-marketing cfix';
      break;
    default:
      footerClassName = 'footer-marketing cfix';
  }
  return (
    <div data-bem="PopupFooter" className={footerClassName}>
      <div className="info-text">
        {withCheckBox && (
          <Checkbox isChecked={finalAgreeToSend || false} id="agreeSend" onCheckboxClick={setFinalAgreeToSend} />
        )}
        <p>{footerInfo}</p>
      </div>
      <div className="marketing-button-container" style={{ justifyContent: 'space-around' }}>
        <button className="sms-btn-white" onClick={leftButtonClick} style={{ marginRight: '0' }}>
          {leftButtonTitle}
        </button>
        {(variant !== POPUP_FOOTER_VARIANTS.ONLINE ||
          (!isReceptionist && variant === POPUP_FOOTER_VARIANTS.ONLINE)) && (
          <button className={`sms-btn-violet  ${sendSMSVisibility}`} onClick={rightButtonClick}>
            {rightButtonTitle}
          </button>
        )}
      </div>
    </div>
  );
};

PopupFooter.defaultProps = {
  withCheckBox: false,
  finalAgreeToSend: false,
  disabled: false,
  fromAppointment: false,
  isReceptionist: false,
};

export default PopupFooter;
